export class AllowedDate {
  public static readonly maxAllowedAge = 18;

  public static readonly earliestBirthDate = new Date(1900, 0, 1);

  public static readonly maxAllowedDate = new Date(
    new Date().setFullYear(new Date().getFullYear() - AllowedDate.maxAllowedAge)
  );

  public static readonly firstOfCurrentMonth = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    1
  );

  public static readonly today = new Date();
  public static readonly tomorrow = new Date(
    new Date().setDate(new Date().getDate() + 1)
  );
  public static readonly oneYearAhead = new Date(
    new Date().setFullYear(new Date().getFullYear() + 1)
  );

  public static readonly oneYearBack = new Date(
    new Date().setFullYear(new Date().getFullYear() - 1)
  );
}
